import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { getDepartments } from "../../actions/userActions/departmentAction";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton, Tooltip } from "@mui/material";
import Pagination from "../paginatioin/pagination";
import EditButton from "../subComponents/buttons/EditButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import HeaderComponent from "../reuse_components/HeaderComponent";

import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import SearchInput from "../subComponents/search/SearchInput";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import AddDepartments from "./AddDepartments";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Departments() {
  const dispatch = useDispatch();
  const history = useHistory();
  const query = useQuery();
  const initialPageNumber = parseInt(query.get("page")) || 1;
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  const [currentPageNumber, setCurrentPageNumber] = useState(initialPageNumber);
  const [searchQuery, setSearchQuery] = useState(query.get("search") || "");
  const [previousQuery, setPreviousQuery] = useState("");
  const [permission, setPermission] = useState(false)
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [departmentData, setdepartmentData] = useState([]);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    const pageNumber = currentPageNumber;

    if (searchQuery !== previousQuery) {
      setCurrentPageNumber(1);
    }

    dispatch(getDepartments(currentPage, itemsPerPage, searchQuery));
    setPreviousQuery(searchQuery);
    setButtonPermission()
  }, [currentPage, searchQuery]);

  const departments = useSelector((state) => state.departments_reducer.departments);
 
  const departmentsData = departments?.result || [];
  const totalPages = departments.totalPages || 0;
  const totalItems = departments?.totalCount || 0;

  const isLoading = useSelector((state) =>  state.departments_reducer.isDepartmentLoading);
 
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  useEffect(() => {
    const departmentData = departments && departmentsData;
    const DepartmentsData = departmentData?.map((departments) => ({
      ...departments,
      status: (
        <span className={departments.active ? "status-badge-active" : "status-badge-inactive"}>
          {departments.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setdepartmentData(DepartmentsData);
  }, [departments]);

  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getDepartments(pageNumber, value, searchQuery));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const columns = [
    { label: `${t("name")}`, accessor: "name" },
    { label: `${t("description")}`, accessor: "description" },
     { label: `${t("status")}`, accessor: "status" },  
  ];
 
  const handleAddDepartmentClick = () => {
    setEditData(null);
    setShowModal(true);
  };

  const handleEditDepartment = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleSaveData = async (newData) => {
    dispatch(getDepartments(currentPage, itemsPerPage, searchQuery));
    setShowModal(false);
  };
  const actions = [  
    {
        label: 'Edit Department',
        icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
        permission: 'CanUpdateDepartment',
        handler:handleEditDepartment,
    },
];

const handleSearchChange = (e) => {
  setSearchQuery(e.target.value);
  setCurrentPage(1);
};
  const setButtonPermission = () => {
    if(permissions.includes('CanAddEmployee')){
      setPermission(true);
    }
  }

  return (
    <>
     <div>
      <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
              <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
              value={searchQuery}
                    />
                  <div className="flex-align-center">
                  <div className="items-per-page-container">
                  <ItemsPerPageSelector
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  />
                </div>
                       <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
    {permissions && permissions.includes("CanAddDepartment") && (
                            <CustomButton text={t("addNew")} onClick={handleAddDepartmentClick} />
                        )}
                    </div>
                </div>

            </div>

                <DynamicTable
                    data={ departmentData}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                    showPagination={totalItems > 0}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    totalPages={totalPages}
                    onPageChange={(page) => setCurrentPage(page)}
                    onItemsPerPageChange={handleItemsPerPageChange}
                />
        </div>
          
        {showModal && (
        <AddDepartments
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
      </div>
   
    </>
  );
}

export default Departments;
